var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.62268e-07 6C-2.25842e-07 5.16667 0.155741 4.38611 0.467223 3.65833C0.778705 2.93056 1.20699 2.29444 1.75209 1.75C2.29718 1.20556 2.93405 0.777777 3.66269 0.466666C4.39134 0.155555 5.17282 -3.85848e-07 6.00715 -3.49378e-07C6.84148 -3.12909e-07 7.62296 0.155555 8.35161 0.466666C9.08025 0.777778 9.71712 1.20556 10.2622 1.75C10.8073 2.29444 11.2356 2.93056 11.5471 3.65833C11.8586 4.38611 12.0143 5.16667 12.0143 6L12.0143 6.38333L13.3159 5.08333L14 5.76667L11.5471 8.21667L9.09416 5.76667L9.79499 5.08333L11.0131 6.3L11.0131 5.91667C11.0131 4.52778 10.5264 3.36111 9.55304 2.41667C8.57966 1.47222 7.3977 1 6.00715 1C4.61661 1 3.43464 1.48611 2.46126 2.45833C1.48788 3.43056 1.00119 4.61111 1.00119 6C1.00119 7.38889 1.48788 8.56944 2.46126 9.54167C3.43464 10.5139 4.61661 11 6.00715 11L6.00715 12C5.17282 12 4.39134 11.8444 3.66269 11.5333C2.93405 11.2222 2.29718 10.7944 1.75209 10.25C1.20699 9.70556 0.778704 9.06944 0.467223 8.34167C0.15574 7.61389 -2.98694e-07 6.83333 -2.62268e-07 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.1455e3517afe7b7da13b2582592491e3.svg";
export { ForwardRef as ReactComponent };